import React from "react";
import { observer } from "mobx-react";
import { ItemsContainer } from "./Items.styled";
import NoteItem from "../../../../components/itemList/NotesItemList";

const Items = observer(({ items = [], onOpenNote, onDeleteNote }) => {
  return (
    <ItemsContainer>
      {items.map((note) => (
        <NoteItem
          key={note.id}
          info={note}
          onOpen={onOpenNote}
          onDelete={onDeleteNote}
        />
      ))}
    </ItemsContainer>
  );
});

export default Items;
